import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-card-container',
    templateUrl: './card-container.component.html',
    styleUrls: ['./card-container.component.scss'],
    standalone: true
})
export class CardContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
